import { useTranslation } from 'react-i18next'
import NBSIcon from '~/assets/icons/nbs.svg?react'
import { Headline } from '../typography'

export default function Header() {
  const { t } = useTranslation()
  return (
    <header className="sticky flex items-center justify-between px-3 py-4 text-left">
      <div className="flex items-center gap-2">
        <NBSIcon className="h-10 w-10" />
        <div className="flex flex-col">
          <Headline level={5} className="text-[#013E74]">
            {t('panel.cosmosAdapt')}
          </Headline>
        </div>
      </div>
    </header>
  )
}
